const webApp = {
    property: [
        { text: 'Name', value: 'name' },
        { text: 'Url', value: 'url' },
        { text: 'Status', value: 'autotstart' }
    ],
    list: [{
            name: 'jmeet',
            url: 'meet.ypcloud.com ',
            src: require('@/assets/images/apps/smartscreen_512x512.png')
        },
        {
            name: 'ultraview',
            url: 'ultraview.ypcloud.com',
            src: require('@/assets/images/apps/grafana_512x512.png')
        },
        {
            name: 'iocview',
            url: 'iocview.ypcloud.com',
            src: require('@/assets/images/apps/ioc_512x512.png')
        },
        {
            name: 'jbuilder',
            url: 'jbuilder.ypcloud.com',
            src: require('@/assets/images/apps/jbuilder_512x512.png')
        },
        {
            name: 'zoom',
            url: 'zoom.us',
            src: require('@/assets/images/apps/zoom_512x512.png')
        }
    ]
}
export default webApp;